import React from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";

function ScreenLoadingIcon(): React.JSX.Element {
  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
  },
});

export default ScreenLoadingIcon;
